import React from 'react';
import { BrowserRouter, Switch, Redirect } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthService } from '@vis-auth/vis-auth';
import { AuthServiceProvider, AuthStateProvider, SecureRoute } from '@vis-auth/react';
import { SaveModRoutes } from '@save/utils';
import MessageCenter from './pages/message-center/message-center';
import Home from './pages/home/home';
import SupportedBrowsers from './pages/supported-browsers/supported-browsers';

export default function Root({ authService }: { authService?: AuthService }) {
  return (
    <BrowserRouter>
      <AuthServiceProvider value={authService}>
        <AuthStateProvider>
          <HelmetProvider>
            <Switch>
              <SecureRoute exact path={SaveModRoutes.HOME}>
                <Home />
              </SecureRoute>
              <SecureRoute exact path={SaveModRoutes.HOME_LOGIN_DOT_GOV_REDIRECT}>
                <Redirect to={SaveModRoutes.HOME} />
              </SecureRoute>
              <SecureRoute exact path={SaveModRoutes.MESSAGE_CENTER}>
                <MessageCenter />
              </SecureRoute>
              <SecureRoute path={'/save/app/client/ui/home/'}>
                <Redirect to={SaveModRoutes.NOT_FOUND} />
              </SecureRoute>
              <SecureRoute exact path={SaveModRoutes.SUPPORTED_BROWSERS}>
                <SupportedBrowsers />
              </SecureRoute>
            </Switch>
          </HelmetProvider>
        </AuthStateProvider>
      </AuthServiceProvider>
    </BrowserRouter>
  );
}
